module.exports = __webpack_public_path__ + "img/GAME_NIGHTSKY1.830da9fc.jpg";